export default {
  selectLang: "Sprache auswählen",
  footer: {
    copyright: "© 2025 TaxEcoBit. Alle Rechte vorbehalten.",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutzrichtlinie",
    help: "Hilfe oder Vorschläge?",
  },
  menu: {
    dashboard: "Dashboard",
    calculate: "Berechnen",
    calculations: "Berechnungen",
    pricing: "Preise",
    settings: "Einstellungen",
    factors: "Faktoren",
    reports: "Berichte",
    upgrade: "Upgrade",
    usage: "Nutzung",
    invite: "Einladungen",
    home: "Startseite",
    blog: "Blog",
    whitepaper: "Whitepaper",
    about: "Über uns",
    faq: "FAQ",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutzrichtlinie",
    tickets: "Tickets",
    billing: "Abrechnung",
    "billing-overview": "Übersicht",
    "billing-orders": "Bestellungen",
    "billing-invoices": "Rechnungen",
    "billing-subscription": "Abonnement",
    templates: "Vorlagen",
  },
  upgradeWall: {
    successTitle: "Testanfrage erfolgreich",
    successSubtitle: "Sie haben erfolgreich die kostenlose 14-tägige Pro-Testversion beantragt",
    quotaTitle: "Berechnungskontingent:",
    reportQuotaTitle: "Berichtskontingent:",
    planComparison: "Planfunktionsvergleich",
    calculation: "Berechnung",
    report: "Bericht",
    price: "Preis",
    viewPricing: "Vollständige Preisübersicht anzeigen",
    freeTrial: "Kostenlose 14-tägige Pro-Testversion",
    upgradeToPro: "Auf Pro upgraden",
    upgradePro: "Pro upgraden",
    contactSupport: "Support kontaktieren",
    inviteRewards: "Mehr Kontingent durch Einladungen erhalten!",
    inviteRewardsDesc:
      "Laden Sie Freunde zur Registrierung ein, und Sie und Ihre Freunde erhalten zusätzliches Berechnungskontingent",
    inviteFriends: "Freunde einladen",
    quotaExhausted: "Ihr Plan-Kontingent ist erschöpft",
    calculationThreshold: "Ihr Berechnungskontingent ist zu {percent} % genutzt",
    reportThreshold: "Ihr Berichtskontingent ist zu {percent} % genutzt",
    upgradePlan: "Upgrade-Plan",
    free: "Kostenlos",
    basic: "49 €/Monat",
    proPrice: "99 €/Monat",
    timesPerMonth: "mal/Monat",
    plan: "Plan",
    trialSuccess: "Testanfrage erfolgreich",
  },
  ticket: {
    modal_title: "Ticket einreichen",
  },
  brand: {
    what_is_taxecobit: "Was ist TaxEcoBit?",
    taxecobit_description:
      "TaxEcoBit ist eine Compliance-Automatisierungsplattform, die für Unternehmen entwickelt wurde, die vom EU Carbon Border Adjustment Mechanism (CBAM) betroffen sind. Wir helfen Importeuren, Herstellern und KMU bei der Berechnung von produktspezifischen Kohlenstoffemissionen, der Erstellung CBAM-konformer Berichte und der Reduzierung regulatorischer Risiken.",
    taxecobit_benefits: "Mit TaxEcoBit können Benutzer:",
    benefit_accurate_calculations:
      "Genaue Kohlenstoffberechnungen unter Verwendung offizieller und benutzerdefinierter Emissionsfaktoren durchführen",
    benefit_cbam_documents: "CBAM-konforme Dokumente zur Einreichung generieren",
    benefit_carbon_cost_tracking:
      "Kohlenstoffkostenauswirkungen überwachen und operative Effizienz optimieren",
    benefit_api_integration:
      "Compliance-Workflows nahtlos über API mit ERP- und Lieferketten-Systemen integrieren",
    taxecobit_conclusion:
      "Durch den Ersatz manueller Tabellenkalkulationen und Beraterabhängigkeit ermöglicht TaxEcoBit eine schnellere, zuverlässigere Compliance bei niedrigeren Betriebskosten.",
  },
  userLevel: {
    label: "Benutzerebene",
    highest_level: "Höchste Ebene",
    next_level: "Nächste Ebene: {level}",
    standard_user: "Standardbenutzer",
    bronze_user: "Bronze-Benutzer",
    silver_user: "Silber-Benutzer",
    gold_user: "Gold-Benutzer",
    platinum_user: "Platin-Benutzer",
    bronze_next: "Bronze (50 Berechnungen)",
    silver_next: "Silber (150 Berechnungen)",
    gold_next: "Gold (300 Berechnungen)",
    platinum_next: "Platin (600 Berechnungen)",
    highest_level_text: "Höchste Ebene erreicht",
  },
  notification: {
    title: "Benachrichtigungen",
    settings: "Benachrichtigungseinstellungen",
    preferences: "Benachrichtigungseinstellungen",
    email_notifications: "E-Mail-Benachrichtigungen",
    app_notifications: "App-Benachrichtigungen",
    all: "Alle Benachrichtigungen",
    important: "Nur wichtige Benachrichtigungen",
    none: "Keine Benachrichtigungen",
    save_preferences: "Benachrichtigungseinstellungen speichern",
    success_message: "Benachrichtigungseinstellungen erfolgreich gespeichert",
    error_message: "Speichern der Benachrichtigungseinstellungen fehlgeschlagen",
    detail_title: "Benachrichtigungsdetails",
    mark_as_read: "Als gelesen markieren",
    not_found_title: "Benachrichtigung nicht gefunden",
    not_found_desc: "Die gesuchte Benachrichtigung existiert nicht oder wurde gelöscht.",
    search_placeholder: "Nach Titel oder Inhalt suchen",
    email_sent: "E-Mail gesendet",
    in_app_only: "Nur in App",
    no_notifications: "Keine Benachrichtigungen",
    total: "Insgesamt {total} Benachrichtigungen",
    fetch_failed: "Benachrichtigungen konnten nicht abgerufen werden",
    marked_as_read: "Erfolgreich als gelesen markiert",
    mark_failed: "Markierung als gelesen fehlgeschlagen",
    mark_all_read: "Alle als gelesen markieren",
    view_all: "Alle anzeigen",
  },
  notFound: {
    title: "404 Nicht gefunden",
    description: "Entschuldigung, die von Ihnen besuchte Seite existiert nicht.",
    goHome: "Zur Startseite gehen",
  },
  login: {
    sign_in: "Anmelden",
    sign_up: "Registrieren",
    password_rule_length: "Mindestens 8 Zeichen",
    password_rule_letter: "Enthält englische Buchstaben",
    password_rule_number: "Enthält Zahlen",
    password_rule_special: "Enthält Sonderzeichen {0}",
  },
};
